import * as rdd from 'react-device-detect';

export function useDeviceDetect() {
  const isChrome = rdd.isChrome;
  const isFireFox = rdd.isFirefox;
  const isSafari = rdd.isSafari;

  return {isChrome, isFireFox, isSafari};
}
